/**
 * Zollinstruktionen an einer Bestellung (Spec 2026-10-30-zollinstruktionen-design.md).
 *
 * NEUBAU ohne Vorbild in `index.html` und deshalb NICHT in `MODULE` von `frontend/scripts/gen-herkunft.ts`
 * eingetragen (dort stehen nur die portierten Module).
 *
 * Ob die Zollinstruktionen "angestossen" sind, steht in keinem eigenen Feld, sondern im Task
 * „Zollinstruktionen an Spedition senden (Outlook)" der Bestellung: der Knopf „Zollinstruktionen
 * anstoßen" (Reiter Spedition) erzeugt die Datei und hakt diesen Task ab - beides in einem Schritt, am
 * Server. Das Board liest daher nur `order.tasks[]` und braucht weder einen Nachlader noch einen
 * eigenen Wert in der Bestellliste.
 */
import type { Order } from "./types.ts";

/** Titel des Tasks, den der Server beim Anstossen abhakt - wortgleich zum Backend (`ZOLL_TASK_TITEL`). */
export const ZOLL_TASK_TITEL = "Zollinstruktionen an Spedition senden (Outlook)";

/**
 * Der Satz im Fehlerstapel, wenn der Knopf samt Dialog nicht angezeigt werden kann (Chunk nicht ladbar, Absturz beim Zeichnen). Steht
 * hier statt in den Komponenten: `ZollKnopfLazy.tsx` (Eintritt) und `ZollKnopf.tsx` (Chunk) brauchen ihn beide, und dieses Modul
 * liegt ohnehin in beiden.
 */
export const ZOLL_ANZEIGE_FEHLER = "Die Zollinstruktionen konnten nicht angezeigt werden.";

const ZOLL_TASK_TITEL_KLEIN = ZOLL_TASK_TITEL.toLowerCase();

/**
 * `true`, wenn `titel` der Titel des Zoll-Tasks ist: nur Zeichenketten, getrimmt und ohne Beachtung der
 * Gross-/Kleinschreibung - dieselbe Regel wie `istZollTaskTitel` im Backend. `OrderTask.name` ist
 * `unknown`, deshalb der Typ.
 */
export function istZollTaskTitel(titel: unknown): boolean {
  return typeof titel === "string" && titel.trim().toLowerCase() === ZOLL_TASK_TITEL_KLEIN;
}

/**
 * `true`, wenn die Bestellung einen ERLEDIGTEN Zoll-Task traegt (`done === true`, keine
 * Wahrheitspruefung: `done` ist `unknown`). Ein offener Task, ein Task mit anderem Titel, eine fehlende
 * oder unbrauchbare `tasks`-Liste ergeben `false`; kaputte Eintraege in der Liste werden uebergangen.
 */
export function zollinstruktionenAngestossen(order: Order): boolean {
  const tasks: unknown = order.tasks;
  if (!Array.isArray(tasks)) return false;
  return tasks.some((task: unknown) => {
    if (task === null || typeof task !== "object") return false;
    const eintrag = task as { name?: unknown; done?: unknown };
    return istZollTaskTitel(eintrag.name) && eintrag.done === true;
  });
}
